export default __webpack_public_path__ + "static/media/phonebooth_closeUp.083c1e19.webp";